export default __webpack_public_path__ + "images/stripe-payment-element/china-union-pay-35b08be11ddba3e884b4d1139b429596.svg";